// extracted by mini-css-extract-plugin
module.exports = {"button":"_2MHC_c","container":"_2fVFPn","leftBlock":"_2xPymZ","logo":"_3rUxUU","text":"xHwIBI"};